/** Mesmo build atende o painel (app.*) e o console da plataforma (console.*). */
export const isAdminHost = () => window.location.hostname.startsWith('console.');

/** Domínio base (sem app./console. e sem porta): as clínicas ficam em {slug}.base. */
export const baseHost = () => window.location.hostname.replace(/^(app|console)\./, '');

/** Link para o portal de uma clínica. Em dev o portal roda na porta 5174. */
export function portalUrl(host: string): string {
  const port = import.meta.env.DEV ? ':5174' : '';
  return `${window.location.protocol}//${host}${port}`;
}
